























import {Component, Vue} from 'vue-property-decorator';
import DiagramLegendNoCard from '@c/diagrams/DiagramLegendNoCard.vue';

@Component({
  components: {DiagramLegendNoCard},
})
export default class FacilityStructureTree extends Vue {
  menu = false;

  legendData = [
    {color: 'white', name: 'Статус неизвестен'},
    {color: '#FFEB7F', name: 'Дубликат мак-адреса'},
    {color: '#76FEC5', name: 'Есть подключения'},
    {color: '#FF756B', name: 'Нет подключений'},
  ];
}
